import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=6613e1b9&"
import script from "./VideoPlayer.js?vue&type=script&lang=js&"
export * from "./VideoPlayer.js?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports